import { RefObject, useCallback } from 'react';

import { ApiJobId } from 'api/types/ApiTypedId';

type Args = {
  scrollingParentRef: RefObject<HTMLElement | null>;
};

export function useViewJobPageSidebarResultsScroll({
  scrollingParentRef,
}: Args) {
  const scrollToJobId = useCallback(
    (jobId: ApiJobId) => {
      const scrollingParent = scrollingParentRef.current;
      if (!scrollingParent) return;

      const hitElement = scrollingParent.querySelector(
        `[data-hit-id="${jobId}"]`,
      ) as HTMLElement | null;

      if (!hitElement) return;

      const isFirstChild =
        hitElement.parentNode?.firstElementChild === hitElement;

      /* When the user selects the first search hit, we want to show the "save search" button
       * This number doesn't have to be exact, it just needs to be big enough to reach the top of the scrolling container
       */
      const scrollMarginTop = isFirstChild ? 200 : 8;

      // Don't use hitElement.scrollIntoView() - it can cause the whole body to scroll
      scrollingParent.scrollTo(0, hitElement.offsetTop - scrollMarginTop);
    },
    [scrollingParentRef],
  );

  return { scrollToJobId };
}
